import { useMutation } from '@tanstack/react-query';
import { fetchCreateBettingSessionDemo } from './service';
import { GenericError } from '@/models/generic-error';
import { AxiosError } from 'axios';
import { AnyAction, Dispatch } from 'redux';
import { useDispatch } from 'react-redux';
import { setHasSlotSession } from '@/lib/store/casino/actions';
import { CreateBettingSessionDemoInputDto } from '@/services/dto/betiing-session/create-betting-session-demo-input.dto';
import { CreateBettingSessionDemoOutputDto } from '@/services/dto/betiing-session/create-betting-session-demo-output.dto';
import { GamingAggregatorId } from '@/models/gaming-aggregator/id';

export function useCreateBettingSessionDemo() {
  const dispatch: Dispatch<AnyAction> = useDispatch();

  function onSuccess(
    _: CreateBettingSessionDemoOutputDto,
    variables: CreateBettingSessionDemoInputDto,
  ) {
    if (
      variables?.aggregatorId?.toString() ===
      GamingAggregatorId.Softswiss?.toString()
    ) {
      dispatch(setHasSlotSession(true));
    }
  }
  const {
    mutate,
    isPending: isLoading,
    error,
    data,
    isError,
    reset,
  } = useMutation<
    CreateBettingSessionDemoOutputDto,
    AxiosError<GenericError>,
    CreateBettingSessionDemoInputDto
  >({
    mutationFn: fetchCreateBettingSessionDemo,
    onSuccess,
  });

  return {
    createBettingSessionDemo: mutate,
    reset,
    isLoading,
    error,
    isError,
    data,
  };
}
